<template>
    <div class="row justify-content-center u-mt2 has-margins">
        <div class="col-12 col-xs-12 col-md-6">
            <div class="u-form u-mt1">
                <loading :loading="loading"></loading>
                <h3 class="u-mt2" v-if="user.is_creator">Upgrade storage</h3>
                <h3 class="u-mt2" v-else>Upgrade</h3>
                <p v-if="user.is_creator">
                    If you would like to add more storage space, you can do so for a small cost.
                    You currently have {{bytes.purchased | fileSize}} space, of which you have used
                    {{bytes.used | fileSize}}, meaning that you have {{bytes.available | fileSize}} remaining.
                </p>
                <p v-else>
                    If you would like to keep in touch with your loved ones when you are
                    no longer around, you can upgrade to a premium account. The price of
                    this is based on the amount of content you would like to upload and the
                    length of time you would like us to keep hold of that content.
                </p>
                <div class="form-group">
                    <ion-label for="spaceRange">Please select a package?</ion-label>
                    <select class="form-control" v-model="selectedPackage">
                        <option value disabled class="display-none">Select a package</option>
                        <option
                            :value="product"
                            v-for="product in products"
                            v-bind:key="product.id"
                        >{{product.title}}</option>
                    </select>
                    <p class="help-text">{{selectedPackage.description}}</p>
                </div>

                <div class="-price">{{moneyFormat(selectedPackage.priceAsDecimal)}}</div>
                <div v-if="hasSelected">
                    <p class="help-text">
                        {{showSpace}} - {{showSpaceHelper}}
                    </p>
                </div>

                <div>
                    <p>Payment is made using an In-App Purchase.</p>
                </div>
                <div class="u-mt1 text-center" :class="paying ? 'invisible' : 'visible'">
                    <ion-button
                        shape="round"
                        expand="full"
                        v-on:click="pay()"
                        color="medium"
                        style="color : var(--ion-color-dark);"
                    >Checkout</ion-button>
                </div>

                <div class="u-mt1 text-center" v-if="paying">
                    <i class="fas fa-circle-notch fa-spin fa-3x"></i>
                </div>
                <ion-button
                    shape="round"
                    expand="full"
                    v-on:click="onCancel()"
                    color="medium"
                    style="color : var(--ion-color-dark);"
                >Cancel</ion-button>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import { alerts } from "@/mixins/alerts";
import { registration } from "@/mixins/registration";
import { formatting } from "@/mixins/formatting";
import { device } from "@/mixins/device";
export default {
    mixins: [alerts, registration, formatting, device],
    name: "UpgradeDevice",
    data: function() {
        return {
            product_ids: {
                "com.mobilerocket.ghost.package.1" : {s : 500, y : 1},
                "com.mobilerocket.ghost.package.2" : {s : 2000, y : 5},
                "com.mobilerocket.ghost.package.3" : {s : 3000, y : 10},
                "com.mobilerocket.ghost.package.4" : {s : 4000, y : 30},
                "com.mobilerocket.ghost.package.5" : {s : 5000, y : 50}
            },
            errors: {},
            posting: false,
            hasSelected : false,
            time: 5,
            space: 2000,
            paid: false,
            paying: false,
            paypal: {},
            products: [],
            // iosPackage: {
            //     price: "",
            //     description: "",
            //     productId: null,
            //     title: ""
            // },
            selectedPackage: "",
            loading: true,
            bytes: {
                used: 0,
                purchased: 0,
                available: 0
            }
        };
    },
    props: {
        onCancel: {
            type: Function,
            default: function() {
                this.$router.push({ name: "profile" });
            }
        },
        onSuccess: {
            type: Function,
            default: function() {
                this.$router.push({ name: "home" });
            }
        }
    },
    watch : {
        selectedPackage : function (val) {
            console.log('SELECTED PACKAGE', val)
            let p = this.product_ids[val.productId];
            if (p) {
                this.time = p.y;
                this.space = p.s;
                this.hasSelected = true;
            } else {
                this.hasSelected = false;
            }
        }
    },
    mounted: function() {
        let self = this;
        console.log("PRODUCTS", this.product_ids);
        let product_ids = Object.keys(this.product_ids);
        console.log("PRODUCT IDS", product_ids);
        inAppPurchase
            .getProducts(product_ids)
            .then(function(products) {
                console.log("PRODUCTS", products);
                self.products = products;
                /*
                [{ productId: 'com.yourapp.prod1', 'title': '...', description: '...', currency: '...', price: '...', priceAsDecimal: '...' }, ...]
                */
            })
            .catch(function(err) {
                console.log(err);
            });
        if (this.user.is_creator) {
            this.time = parseInt(this.$root.user.years); // odd this...
            // get the storage...
            this.checkSpace();
        } else {
            this.loading = false;
        }
    },
    components: {
        Loading
    },
    computed: {
        user: function() {
            return this.$root.user;
        }
    },
    methods: {
        checkSpace: function() {
            let self = this;
            this.loading = true;
            this.axios
                .get(this.api + "users/space")
                .then(response => {
                    self.bytes = response.data;
                    self.loading = false;
                })
                .catch(error => {
                    self.loading = false;
                    console.error("error setting space", error);
                });
        },
        showYears: function(t) {
            if (t == 1) {
                return "1 Year";
            }
            return t + " Years";
        },
        showGbs: function(g) {
            if (g == 500) {
                return "500MB";
            }
            let gb = g / 1000;
            return gb + "GB";
        },
        pay: function() {
            let self = this;
            if (!this.selectedPackage.productId) {
                this.showError("Please pick a package from the dropdown menu");
                return;
            }
            let productId = this.selectedPackage.productId;
            this.paying = true;
            inAppPurchase
                .buy(productId)
                .then(function(data) {
                    console.log("IN APP PURCHASE", data);
                    // post to axios with the receipt details.
                    // {
                    //     transactionId: ...
                    //     receipt: ...
                    //     signature: ...
                    // }
                    let params = {
                        receipt: data,
                        product_id: productId
                    };
                    self.axios
                        .post(self.api + "inapppurchase", params)
                        .then(response => {
                            self.paying = false;
                            self.showSuccess(
                                "Purchase successfuly, thank you!",
                                function() {
                                    self.axios
                                        .post(self.api + "auth/me")
                                        .then(response => {
                                            self.$root.setUser(response.data);

                                            self.$router.push("/");
                                        })
                                        .catch(error => {
                                            console.error(
                                                "ERROR getting me",
                                                error
                                            );
                                        });
                                }
                            );
                        })
                        .catch(error => {
                            self.paying = false;
                            console.log(
                                "ERROR PROCESSING IN APP PURCHASE",
                                error
                            );
                            self.showError(
                                "It looks like there was an error processing payment, please let us know if there are further issues"
                            );
                        });
                })
                .catch(function(err) {
                    self.paying = false;
                    console.log("ERROR WITH IN APP PURCHASE", err);
                    self.showError(
                        "It looks like there was an error taking payment, please let us know if there are further issues"
                    );
                });
        }
    }
};
</script>

<style>
.-price {
    font-weight: 600;
    color: var(--ion-color-dark);
    font-size: 1.2rem;
}
.help-text {
    color: var(--ion-color-medium);
    font-weight: 100;
    text-align: left;
}
.help-text.-strong {
    font-weight: 600;
    color: var(--ion-color-dark);
}
input[type="range"] {
    -webkit-appearance: none;
    width: 100%;
    margin: 5px 0;
}
input[type="range"]:focus {
    outline: none;
}
input[type="range"]::-webkit-slider-runnable-track {
    width: 100%;
    height: 6px;
    cursor: pointer;
    background: var(--ion-color-light);
    border-radius: 2px;
    border: 0px solid #ffffff;
}
input[type="range"]::-webkit-slider-thumb {
    border: 1px solid #ffffff;
    height: 16px;
    width: 16px;
    border-radius: 8px;
    background: var(--ion-color-primary);
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -5px;
}
input[type="range"]:focus::-webkit-slider-runnable-track {
    background: var(--ion-color-light);
}
input[type="range"]::-moz-range-track {
    width: 100%;
    height: 6px;
    cursor: pointer;
    background: var(--ion-color-light);
    border-radius: 2px;
    border: 0px solid #ffffff;
}
input[type="range"]::-moz-range-thumb {
    border: 1px solid #ffffff;
    height: 16px;
    width: 16px;
    border-radius: 8px;
    background: var(--ion-color-dark);
    cursor: pointer;
}
input[type="range"]::-ms-track {
    width: 100%;
    height: 6px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
}
input[type="range"]::-ms-fill-lower {
    background: var(--ion-color-dark);
    border: 0;
    border-radius: 4px;
}
input[type="range"]::-ms-fill-upper {
    background: var(--ion-color-dark);
    border: 0;
    border-radius: 4px;
}
input[type="range"]::-ms-thumb {
    border: 1px solid #ffffff;
    height: 16px;
    width: 16px;
    border-radius: 8px;
    background: var(--ion-color-primary);
    cursor: pointer;
    height: 6px;
}
input[type="range"]:focus::-ms-fill-lower {
    background: #495b64;
}
input[type="range"]:focus::-ms-fill-upper {
    background: #546873;
}
</style>
